<template>
    <div class="data modal-container">
        <div class="modal-header">
            <div class="corner-container left">
                <div>
                    <div class="header-label"> <b> {{ headerText }} </b> </div>
                </div>
                <div>
                    <div class="helper-text"> <b>Guard Attendant:</b> </div>
                    <p class="helper-text-data"> {{ guardAttendant }}</p>
                </div>
                <div>
                    <div class="helper-text"> <b>Visistor Type:</b> </div>
                    <p class="helper-text-data"> {{ type }}</p>
                </div>
            </div>
            <div>
                <div class="circle">
                    <button style="width: 100%; height: 100%;" @click="changeAssignee()">
                        {{ circleText }}
                    </button>
                </div>
            </div>

            <div class="corner-container right">
                <button class="header-label" @click="$emit('close')">X</button>
                <div>
                    <div class="helper-text"> <b>Status</b> </div>
                    <p class="helper-text-data"> {{ status }}</p>
                </div>
                <div>
                    <div class="helper-text"> <b>Key ID</b> </div>
                    <p class="helper-text-data"> {{ keyId }}</p>
                </div>
            </div>

        </div>
        <div class="modal-fields">
            <div class="modal-field">
                <div class="helper-text">Visitor Name</div>
                <p class="center-text"> {{ visitorName }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Resident Name</div>
                <p class="center-text"> {{ residentName }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Visiting Address</div>
                <p class="center-text"> {{ visitingAddress }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Visitor Entry Time</div>
                <p class="center-text"> {{ visitorEntryTime }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Visitor License Plate</div>
                <p class="center-text"> {{ visitorLicensePlate }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Visitor Vehicle Type</div>
                <p class="center-text"> {{ visitorVehicleType }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Visitor Phone Number</div>
                <p class="center-text"> {{ visitorContact }}</p>
            </div>
            <div class="modal-field">
                <div class="helper-text">Visiting Reason</div>
                <p class="center-text"> {{ unitAddress }}</p>
            </div>
        </div>
        <!-- <div v-if="role == 'admin'">
            <div class="button-container">
                <button class="action-button" @click="editUser()">Add Visitor Info</button>
                <button class="action-button suspended-button" @click="updateIncident()">Log Incident</button>
            </div>
            <div class="button-container">
                <button class="validate button" @click="suspendUser()">Send Message</button>
            </div> 
        </div>
        <div v-else>
            <div class="button-container">
                <button class="action-button" @click="editUser()">Add Visitor Info</button>
                <button class="action-button suspended-button" @click="updateIncident()">Log Incident</button>
            </div>
        </div> -->

    </div>
</template>

<script>
import * as Constants from '../../js/constants'
const NAME = Constants.ENTRY_LOG_MODAL

export default {
    modalName: NAME,
    components: {
    },
    props: ["organizationData", "userData", "entryLogData"],
    watch: {
        entryLogData: function (newVal) {
            console.log("new entry log data val", newVal)
        }
    },
    data() {
        return {
            modalName: NAME,
            suspended: false,
            inactive: true,
            showId: false,
            date: new Date(),
            payload: {},
        }
    },
    methods: {
        show() {
            this.$modal.show();
        },
        close() {
            this.$modal.hide();
        },
        showKey() {
            console.log("show key...")
        },
        showIncidents() {
            console.log("show incidents...")
        },
        edit() {
            console.log("edit mode!")
        },
        editUser() {
            console.log("edit user...")
        },
        addSecondaryUser() {
            console.log("add user...")
        },
        suspendUser() {
            console.log("suspend user...")
        },
        showUserId() {
            this.showId = true
        },
        hideUserId() {
            this.showId = false
        },
        uploadAttachment() {
            alert("Upload Attachment")
        },
        changeAssignee() {
            alert("Change Assignee")
        },
        addComment() {
            alert("Add Comment")

        },
        updateIncident() {
            alert("Update Incident")

        },
        getMappedName(id) {
            return this.$organizationMap[id] ?? id
        }
    },
    computed: {
        headerText: function () {
            return `${this.getMappedName(this.$props.organizationData.organization_id)}`
        },
        guardAttendant: function () {
            return `${this.$props.entryLogData.authorizer_first_name} ${this.$props.entryLogData.authorizer_last_name}`
        },
        type: function () {
            return this.$props.entryLogData.type
        },
        circleText: function () {
            return `${this.$props.entryLogData.visitor_first_name[0]}${this.$props.entryLogData.visitor_last_name[0]}`
        },
        status: function () {
            return this.$props.entryLogData.action
        },
        keyId: function () {
            return this.$props.entryLogData.entity_id
        },
        visitorName: function () {
            return this.$props.entryLogData.visitor_name
        },
        residentName: function () {
            return this.$props.entryLogData.resident_name
        },
        visitingAddress: function () {
            return this.$props.entryLogData.visiting_address
        },
        visitorEntryTime: function () {
            return this.$props.entryLogData.readable_entry_time
        },
        visitorLicensePlate: function () {
            return this.$props.entryLogData.visitor_license_plate
        },
        visitorVehicleType: function () {
            return `-----------------------`
        },
        unitId: function () {
            return ""
        },
        unitAddress: function () {
            return ""
        },
        unitAddressPreview: function () {
            return ""
        },
        visitorContact: function () {
            return this.$props.entryLogData.visitor_contact
        },
        role: function () {
            return this.$props.userData['custom:cts_role']
        },
        associatedUsers: function () {
            return ""
        }
    },
    created() { },
    mounted() {
        console.log("Entry Log Modal", JSON.parse(JSON.stringify(this.$props)))

    }
}
</script>

<style></style>
